/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'
import VanDatetimePicker from 'vant/es/datetime-picker'
import 'vant/es/datetime-picker/style/less'
import VanField from 'vant/es/field'
import 'vant/es/field/style/less'
import VanForm from 'vant/es/form'
import 'vant/es/form/style/less'


import { render, staticRenderFns } from "./idMessage.vue.js?vue&type=template&id=706ae8dd&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./idMessage.vue?vue&type=template&id=706ae8dd&scoped=true"
import script from "./idMessage.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./idMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./idMessage.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./idMessage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./idMessage.vue.css?vue&type=style&index=0&id=706ae8dd&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./idMessage.vue?vue&type=style&index=0&id=706ae8dd&prod&lang=css"
import style1 from "./idMessage.vue.postcss?vue&type=style&index=1&id=706ae8dd&prod&lang=postcss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./idMessage.vue?vue&type=style&index=1&id=706ae8dd&prod&lang=postcss&scoped=true"
import style2 from "./idMessage.vue.css?vue&type=style&index=2&id=706ae8dd&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./idMessage.vue?vue&type=style&index=2&id=706ae8dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ae8dd",
  null
  
)

export default component.exports
installComponents(component, {VanButton,VanDatetimePicker,VanField,VanForm})
